import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

export default class Asignar extends FormComponent {
  componentDidMount() {
    this.initial = true;
    this.FormConfig(
      { defaultUrl: "", saveUrl: "", backUrl: "" },
      new Form(
        [
          Form.Section("Chofer"),
          Form.Field("hidden", "id_chofer", "", "", [Validators.required], 0),
          Form.Field("autocomplete","operador_nombre","Buscar Chofer","",[Validators.required],6),
          Form.Field("select", "id_transportista", "Transportista", "", [Validators.required], 6, [], [], [], false, true),
          Form.Field("text", "chofer_numero_licencia", "Licencia Chofer", "", [Validators.required, Validators.maxLength(16), Validators.minLength(6) ], 6),
          Form.Field("text","chofer_rfc","RFC Chofer","",[Validators.required, Validators.rfc_fisica],6),
          Form.Field("number","chofer_codigo_postal","Codigo Postal","",[Validators.required],6),
          Form.Field("select","chofer_id_colonia","Colonia","",[Validators.required],6),
          Form.Field("text","chofer_calle","Calle","",[Validators.required],6),
          Form.Field("text","chofer_numero","Numero Exterior","",[Validators.required],6),
          Form.Section("Camion"),
          Form.Field("hidden", "id_camion", "", "", [Validators.required], 0),
          Form.Field("autocomplete","camion","Clave camion","",[Validators.required], 6),
          Form.Field("select","id_permiso_sct","Persmiso SCT","",[Validators.required], 6),
          Form.Field("text","camion_permiso_sct","Numero Persmiso SCT","",[Validators.required], 6),
          Form.Field("text","camion_poliza_seguro","Póliza Seguro","",[Validators.required], 6),
          Form.Field("text","camion_aseguradora","Nombre Aseguradora","",[Validators.required],6),
          Form.Field("text","camion_placas","Placas Camión","",[Validators.required],6),
          Form.Field("number","camion_modelo","Modelo Camión","",[Validators.required],6),
          Form.Field("select","id_configuracion_vehicular","Config Vehicular","",[Validators.required],6),
          Form.Field("number","PesoBrutoVehicular", "PesoBrutoVehicular(Toneladas)","",[Validators.required],6),
        ],
        ["Guardar"],
        ""
      ),
      this.formData
    );
    // if (this.props.match.params.id)
    this.LoadPreds(this.props.id);
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;

    if (this.initial) {
      params["initial"] = true;
    }
    if (this.choferChangeAuto) {
      params["chofer"] = this.choferChangeAuto;
      this.choferChangeAuto = null;
    }
    if (this.choferId) {
      params["choferid"] = this.choferId;
      this.choferId = null;
    }
    if (this.formCp) {
      params["chofercp"] = this.formCp;
      this.formCp = null;
    }
    if (this.camionChangeAuto) {
      params["camion"] = this.camionChangeAuto;
      this.camionChangeAuto = null;
    }
    if (this.camionId) {
      params["camionid"] = this.camionId;
      this.camionId = null;
    }

    const Res = await Http.get(
      `preguia/asigancion/form?${objectAsParams(params)}`
    );

    if (!Res.error) {
      const { choferes, choferes_colonias, configAutotransportes, transportistas, camiones, tipos_permiso } = Res.data;
      if (choferes) {
        newForm = Form.FieldOptions(
          newForm,
          "operador_nombre",
          choferes,
          "id",
          "chofer_nombre"
        );
      }
      if (choferes_colonias) {
        newForm = Form.FieldOptions(
          newForm,
          "chofer_id_colonia",
          choferes_colonias,
          "id",
          "colonia"
        );
      }
      if (configAutotransportes) {
        newForm = Form.FieldOptions(
          newForm,
          "id_configuracion_vehicular",
          configAutotransportes,
          "id",
          "descripcion"
        );
      }
      if (transportistas) {
        newForm = Form.FieldOptions(
          newForm,
          "id_transportista",
          transportistas,
          "id",
          "transportista_nombre"
        );
      }
      if (camiones) {
        newForm = Form.FieldOptions(
          newForm,
          "camion",
          camiones,
          "id",
          "camion"
        );
      }
      if (tipos_permiso) {
        newForm = Form.FieldOptions(
          newForm,
          "id_permiso_sct",
          tipos_permiso,
          "id",
          "descripcion"
        );
      }
    }

    if (this.initial) {
      newForm = Form.ValueChange(newForm, {
        operador_nombre: this.choferChange,
        camion: this.camionChange,
        chofer_codigo_postal: this.choferCodigoPoatalChange,
      });
      this.initial = false;
    }

    return newForm;
  };

  LoadPreds = async (predId = null) => {
    /*     let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`/${id}`);
    if (!Res.error) {
      if(!Res.data.llegada_fecha) {
        delete Res.data.llegada_fecha;
      }
      this.setState({ 
        FormData: Form.Patch(this.state.FormData, Res.data, true) 
      }, async () => {
        await this.choferChange({ Value: Res.data.id_chofer });
      })
    }
    this.initial = false; 
     */
  };

  choferChange = async (field) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`unidad-transporte/one/${field.Value}`);
      if (!Res.error) {
        let formData = this.state.FormData;
        const {
          id,
          chofer_calle,
          chofer_rfc,
          chofer_numero_licencia,
          chofer_numero,
          chofer_id_colonia,
          codigo_postal,
          id_transportista,
        } = Res.data;
        this.choferId = id;
        formData = await this.formData(formData);

        this.setState({
          FormData: Form.Patch(
            formData,
            {
              id_chofer: id,
              operador_nombre: id + "",
              chofer_calle,
              chofer_rfc,
              chofer_numero_licencia,
              chofer_numero,
              chofer_id_colonia,
              chofer_codigo_postal: codigo_postal,
              id_transportista,
            },
            false
          ),
        });
      }
    } else {
      this.choferChangeAuto = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData),
      });
    }
  };

  camionChange = async (field) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`camion/one/${field.Value}`);
      if (!Res.error) {
        let formData = this.state.FormData;
        const {
          id,
          camion_placas,
          camion_modelo,
          camion_aseguradora,
          camion_poliza_seguro,
          camion_permiso_sct,
          id_permiso_sct,
          id_configuracion_vehicular,
          PesoBrutoVehicular,
        } = Res.data;
        formData = await this.formData(formData);

        this.setState({
          FormData: Form.Patch(formData, {
            id_camion: id,
            camion_placas,
            camion_modelo,
            camion_aseguradora,
            camion_poliza_seguro,
            camion_permiso_sct,
            id_permiso_sct,
            id_configuracion_vehicular,
            PesoBrutoVehicular,
          }),
        });
      }
    } else {
      this.camionChangeAuto = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData),
      });
    }
  };

  choferCodigoPoatalChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  };

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    vals.id = this.props.id;
    try {
      let Res = await Http.post(`preguia/asignacion/${vals.id}`, vals);
      if (!Res.error) {
        this.setState({ sbMsg: "Guardado", sbOpen: true, loading: false });
        this.props.onClose();
      } else {
        this.setState({ sbMsg: Res.errMsg, sbOpen: true, loading: false });
      }
    } catch (error) {
      console.log(error);
    }
    this.setState({ loading: false });
  };

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    );
  }
}
